import { FULL_CHART_HEIGHT, REDUCED_CHART_HEIGHT } from "./styles";

export const MAX_MD_VIEWPORT_QUERY = "(max-width: 1600px)";

export const BASE_BAR_CHART_PROPS = {
  yAxisLabel: "Operational Risk",
  xAxisLabel: "Field Name",
  yDomainPadding: 1.05,
  withScroll: true,
};

export const LG_BAR_CHART_SIZE = {
  height: FULL_CHART_HEIGHT,
};

export const MD_BAR_CHART_SIZE = {
  height: REDUCED_CHART_HEIGHT,
};

export const SM_BAR_CHART_SIZE = {
  height: FULL_CHART_HEIGHT,
};

export const XS_BAR_CHART_SIZE = {
  height: REDUCED_CHART_HEIGHT,
};

export const NET_MITIGATED_DATA_KEYS_MAP = {
  postMitigationOperationalRisk: "Operational Risk",
  postMitigationWellEntryRisk: "Well Entry Risk",
  netMitigatedRisk: "Net Mitigated Risk",
};

export const REFERENCE_LINE_BASE = {
  strokeDasharray: "2 2",
  strokeWidth: 3,
};
